module.exports = "/next-static/_next/static/images/hero_image_large-9fc66d03a1323f5a980c792411218150.webp";